// TODO: replace token check with getUser() once endpoint is available
import { redirect } from 'react-router';

import { accessTokenService } from '@shared/lib/storage';

export const publicLoader = () => {
  if (accessTokenService.get()) throw redirect('/');
  return null;
};
